let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2pSN4")).then(() => parcelRequire('5276h'));